/** @griffel:css-start [d] null **/
.ftuwxu6{display:inline-flex;}
.flvyvdh{flex-wrap:nowrap;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1t6b6ee{gap:2px;}
.f17g4y64{padding:3px;}
.f100d0uy{border-radius:10px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ac3ntu{background-color:var(--bfTrack);}
.fisytda{min-block-size:32px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
.fx1xsyp{padding-block:0;}
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fwyddsq{border-inline-start-style:solid;}
.fs0v6t2{border-inline-start-color:transparent;}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.fwl1lcr{border-inline-end-style:solid;}
.fwe6w8u{border-inline-end-color:transparent;}
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.f1k290u0{border-block-start-color:transparent;}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f1p2dij1{border-block-end-style:solid;}
.f6kh65l{border-block-end-color:transparent;}
.fz5stix{white-space:nowrap;}
.f10ludwy::after{display:none;}
.fjookjo::before{display:none;}
.fdi6zsv[aria-selected="true"]{background-color:var(--colorNeutralBackground1);}
.f1tnrbr8[aria-selected="true"]{box-shadow:var(--shadow4);}
.f67z7s1[aria-selected="true"]{border-inline-start-color:var(--colorTransparentStroke);}
.foikvm6[aria-selected="true"]{border-inline-end-color:var(--colorTransparentStroke);}
.f1qz8h4t[aria-selected="true"]{border-block-start-color:var(--colorTransparentStroke);}
.f1cujov6[aria-selected="true"]{border-block-end-color:var(--colorTransparentStroke);}
/** @griffel:css-end **/
/** @griffel:css-start [h] null **/
.f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}
/** @griffel:css-end **/